import { Component, Input } from '@angular/core';
import { LaunchpadUser } from '../models/launchpad-user';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, tap } from 'rxjs';
import { LogoutAuthOptions, OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
    selector: 'app-impersonate-user-modal',
    templateUrl: './impersonate-user-modal.component.html',
    styleUrls: ['./impersonate-user-modal.component.sass'],
    standalone: false
})
export class ImpersonateUserModalComponent {
  @Input({ required: true }) user!: LaunchpadUser;

  submitting: boolean = false;
  error: boolean = false;

  constructor(protected activeModal: NgbActiveModal,
              private oidcSecurityService: OidcSecurityService) { }

  confirmImpersonation(): void {
    this.submitting = true;
    this.error = false;
    this.initiateImpersonation().subscribe({
      next: () => {
        this.submitting = false;
        this.activeModal.close();
      },
      error: () => {
        this.submitting = false;
        this.error = true;
      }}
  );
  }

  /**
   * Initiating impersonation logs the user out but user to impersonate is passed
   * in the logout parameters so that IDS can initiate a new login in the impersonation mode
   */
  private initiateImpersonation(): Observable<any> {
    const logoutOptions: LogoutAuthOptions = {
      customParams: {
        "user_to_impersonate": this.user.emailAddress
      }
    };

    return this.oidcSecurityService
      .logoffAndRevokeTokens(undefined, logoutOptions)
      .pipe(tap(() => {
        this.oidcSecurityService.logoffLocalMultiple();
        sessionStorage.clear();
      }));
  }
}
